var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.cities)?_c('div',[_c('VSelect',{attrs:{"disable-clear":false,"options":_vm.cities,"placeholder":_vm.$t('city'),"reduce":(x) => x?.id,"label":"name","track-by":"id"},model:{value:(_vm.syncedFilter),callback:function ($$v) {_vm.syncedFilter=$$v},expression:"syncedFilter"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }